
import { Component, Prop, Vue } from 'vue-property-decorator'
import { clientsModule, commonModule } from '@/store/modules/store-accessor'
import dayjs from 'dayjs'
import { formatAmount, isDecimalNumber } from '@/helpers/data';

const cents = (value: number) => Math.round(value * 100)

@Component
export default class RefundCreditModal extends Vue {
  @Prop() payload!: any;

  loading = false;
  createdAtDateMenu = false;
  createdAtTimeMenu = false;

  refundModel: Record<string, any> = {
    amount: null as number | null,
    payment_type_id: this.paymentTypesCombo[0],
    notes: '',
    created_at_date: dayjs().format('YYYY-MM-DD'),
    created_at_time: dayjs().format('HH:mm'),
  }

  get paymentTypesCombo() {
    return commonModule.paymentTypeCombo;
  }

  get valid() {
    return !!this.refundModel.amount && cents(this.refundModel.amount) > 0 && cents(this.refundModel.amount) <= cents(this.payload.availableCredit) && !!this.refundModel.payment_type_id && this.refundModel.notes.length <= 1000;
  }

  async mounted() {
    await commonModule.getPaymentTypeCombo();
    if (!this.refundModel.payment_type_id) this.refundModel.payment_type_id = this.paymentTypesCombo[0];
  }

  formatAmount(amount: number) {
    return formatAmount(Number(amount) || 0);
  }

  hideModal() {
    commonModule.hideModal();
  }

  onlyDecimalNumbers(evt: KeyboardEvent) {
    isDecimalNumber(evt);
  }

  notesRules = [
    (val: string) => !val || val.length <= 1000 || this.$i18n.t("form_notes_length_rule"),
  ];

  paymentTypeRule = [
    (val: any) => (val || "").id > 0 || this.$i18n.t("payment_type_required"),
  ];

  amountRules = [
    (val: any) => {
      if (val === "" || isNaN(val)) {
        return this.$i18n.t("nonZeroAmountRuleText");
      }
      return cents(Number(val)) > 0 || this.$i18n.t("nonZeroAmountRuleText");
    },
    (val: number) =>
      cents(val) <= cents(this.payload.availableCredit) || this.$i18n.t("availableCreditAmountRuleText"),
  ];

  async doAddRefund() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.loading = true

      try {
        const { created_at_date, created_at_time, payment_type_id, ...rest } = this.refundModel
        await clientsModule.createCreditRefund({
          clientId: this.payload.clientId,
          data: {
            ...rest,
            payment_type_id: payment_type_id.id,
            created_at: dayjs(`${created_at_date} ${created_at_time}`).toISOString(),
          },
        })

        this.hideModal()
      } finally {
        this.loading = false
      }
    }
  }
}
